// extracted by mini-css-extract-plugin
export default {"Spinner":"PlateBatches_Spinner__7ZAf2","Batch":"PlateBatches_Batch__JvsP7","Link":"PlateBatches_Link__9S45G"};